/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
/**
 * A thin wrapper around Promise which allows to save handle for deferred operation
 * and resolve it somewhere in future.
 * Resolvable should be used when you cannot define promise resolution code immediately.
 *
 * @example
 * ```
 * const resolvable = new Resolvable<string>();
 * resolvable.get().then(console.log);
 *
 * resolvable.resolve('Hello World!');
 * ```
 */
class Resolvable<T = any> {
    public resolve: (value?: T | PromiseLike<T>) => void;
    public reject: (reason?: any) => void;
    private promise: Promise<T>;

    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    get() {
        return this.promise;
    }
}

export default Resolvable;
